module.exports = __webpack_public_path__ + "static/media/YB5F18_1.928180ee.jpg";